import { makeStyles } from '@material-ui/core';
import { ColorConstants } from '@shared/constants';

export const useStyles = makeStyles(() => ({
    saveButton: {
        backgroundColor: ColorConstants.FUN_GREEN,
        fontSize: '14px',
        WebkitTextFillColor: ColorConstants.white,
        border: '1px solid transparent',
        width: '120px',
        '&:hover': {
            backgroundColor: ColorConstants.FUN_GREEN,
            opacity: 0.7,
        },
    },
    cancelButton: {
        backgroundColor: 'transparent',
        WebkitTextFillColor: ColorConstants.white,
        fontSize: '14px',
        border: `1px solid ${ColorConstants.white}`,
        width: '120px',
        '&:hover': {
            backgroundColor: 'transparent',
            opacity: 0.7,
        },
    },
    label: {
        margin: 0,
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '24px 0',
    },
}));

export const BACKGROUND_GRADIENT = 'linear-gradient(90.33deg, rgba(0, 0, 0, 0.6) 28.26%, rgba(0, 0, 0, 0.8) 50.01%, rgba(0, 0, 0, 0.6) 72.8%)';
